// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__zCK4T","inputWrap":"Table_inputWrap__2JrR6","col":"Table_col__2-0GI","bmiTooltip":"Table_bmiTooltip__2RC_1"};